import activeUsers from '@/assets/images/icons/active-users.svg';
import aiIcon from '@/assets/images/icons/ai.svg';
import arrowLeftIcon from '@/assets/images/icons/arrow-left.svg';
import arrowRightStartOnRectangleIcon from '@/assets/images/icons/arrow-right-start-on-rectangle.svg';
import arrowRightIcon from '@/assets/images/icons/arrow-right.svg';
import buildingIcon from '@/assets/images/icons/building.svg';
import caretDownIcon from '@/assets/images/icons/caret-down.svg';
import checkIcon from '@/assets/images/icons/check.svg';
import chevronDownIcon from '@/assets/images/icons/chevron-down.svg';
import chevronRightIcon from '@/assets/images/icons/chevron-right.svg';
import chevronSmRightIcon from '@/assets/images/icons/chevron-sm-right.svg';
import chevronUpIcon from '@/assets/images/icons/chevron-up.svg';
import closeIcon from '@/assets/images/icons/close-icon.svg';
import doubleChevronLeftIcon from '@/assets/images/icons/double-chevron-left.svg';
import doubleChevronRightIcon from '@/assets/images/icons/double-chevron-right.svg';
import editDark from '@/assets/images/icons/edit-dark.svg';
import editIcon from '@/assets/images/icons/edit-icon.svg';
import editIconAlt from '@/assets/images/icons/edit.svg';
import exitIcon from '@/assets/images/icons/exit.svg';
import gamePackCardIcon from '@/assets/images/icons/game-pack-card.svg';
import googleIcon from '@/assets/images/icons/google.svg';
import hideIcon from '@/assets/images/icons/hide.svg';
import plusSignIcon from '@/assets/images/icons/plus-sign.svg';
import promptCardIcon from '@/assets/images/icons/prompt-card.svg';
import randomizeBtnIcon from '@/assets/images/icons/randomizeBtnIcon.svg';
import showIcon from '@/assets/images/icons/show.svg';
import shuffleIcon from '@/assets/images/icons/shuffle.svg';
import spinnerIcon from '@/assets/images/icons/spinner.svg';
import starIcon from '@/assets/images/icons/star.svg';
import trashIcon from '@/assets/images/icons/trash.svg';
import undoIcon from '@/assets/images/icons/undo.svg';
import userIcon from '@/assets/images/icons/user.svg';
import vectorIcon from '@/assets/images/icons/vector.svg';
import arrowTipDown from '@/assets/images/icons/arrow-tip-down.svg';
import arrowTipLeft from '@/assets/images/icons/arrow-tip-left.svg';
import arrowTipRight from '@/assets/images/icons/arrow-tip-right.svg';
import arrowTipUp from '@/assets/images/icons/arrow-tip-up.svg';

import { ImgHTMLAttributes, ReactElement } from 'react';

interface IconProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
}

export const Icon = ({ src, alt, ...props }: IconProps): ReactElement => {
  return <img src={src} alt={alt} {...props} />;
};

export const UndoIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={undoIcon} alt="undo icon" {...props} />;
};

export const DeleteIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={trashIcon} alt="trash icon" className="mb-[2px]" {...props} />;
};

export const EditIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={editIcon} alt="pencil and paper for editing" className="mb-[2px]" {...props} />;
};

export const DarkEditIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={editDark} alt="pencil and paper for editing" className="mb-[2px]" {...props} />;
};

export const BuildingIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={buildingIcon} alt="building icon" {...props} />;
};

export const UsersIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={activeUsers} alt="users icon" {...props} />;
};

export const CloseIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={closeIcon} alt="close icon" {...props} />;
};

export const RandomizeBtnIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={randomizeBtnIcon} alt="randomize button icon" {...props} />;
};

export const StarIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={starIcon} alt="star icon" {...props} />;
};

export const GamePackCardIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={gamePackCardIcon} alt="game pack card icon" {...props} />;
};

export const PromptCardIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={promptCardIcon} alt="prompt card icon" {...props} />;
};

export const AiIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={aiIcon} alt="ai icon" {...props} />;
};

export const ArrowLeftIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={arrowLeftIcon} alt="arrow left icon" {...props} />;
};

export const ArrowRightStartOnRectangleIcon = (
  props: ImgHTMLAttributes<HTMLImageElement>
): ReactElement => {
  return (
    <Icon
      src={arrowRightStartOnRectangleIcon}
      alt="arrow right start on rectangle icon"
      {...props}
    />
  );
};

export const ArrowRightIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={arrowRightIcon} alt="arrow right icon" {...props} />;
};

export const CaretDownIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={caretDownIcon} alt="caret down icon" {...props} />;
};

export const CheckIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={checkIcon} alt="check icon" {...props} />;
};

export const ChevronDownIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={chevronDownIcon} alt="chevron down icon" {...props} />;
};

export const ChevronRightIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={chevronRightIcon} alt="chevron right icon" {...props} />;
};

export const ChevronSmRightIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={chevronSmRightIcon} alt="chevron small right icon" {...props} />;
};

export const ChevronUpIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={chevronUpIcon} alt="chevron up icon" {...props} />;
};

export const DoubleChevronLeftIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={doubleChevronLeftIcon} alt="double chevron left icon" {...props} />;
};

export const DoubleChevronRightIcon = (
  props: ImgHTMLAttributes<HTMLImageElement>
): ReactElement => {
  return <Icon src={doubleChevronRightIcon} alt="double chevron right icon" {...props} />;
};

export const EditIconAlt = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={editIconAlt} alt="edit icon" {...props} />;
};

export const ExitIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={exitIcon} alt="exit icon" {...props} />;
};

export const GoogleIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={googleIcon} alt="google icon" {...props} />;
};

export const HideIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={hideIcon} alt="hide icon" {...props} />;
};

export const PlusSignIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={plusSignIcon} alt="plus sign icon" {...props} />;
};

export const ShowIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={showIcon} alt="show icon" {...props} />;
};

export const ShuffleIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={shuffleIcon} alt="shuffle icon" {...props} />;
};

export const SpinnerIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={spinnerIcon} alt="spinner icon" {...props} />;
};

export const UserIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={userIcon} alt="user icon" {...props} />;
};

export const VectorIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={vectorIcon} alt="vector icon" {...props} />;
};

export const ArrowTipDownIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={arrowTipDown} alt="arrow down icon" {...props} />;
};

export const ArrowTipLeftIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={arrowTipLeft} alt="arrow left icon" {...props} />;
};

export const ArrowTipRightIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={arrowTipRight} alt="arrow right icon" {...props} />;
};

export const ArrowTipUpIcon = (props: ImgHTMLAttributes<HTMLImageElement>): ReactElement => {
  return <Icon src={arrowTipUp} alt="arrow up icon" {...props} />;
};

export const SearchIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);
